import { render, staticRenderFns } from "./seaCustomerConfig.vue?vue&type=template&id=35b4bb5a&"
import script from "./seaCustomerConfig.vue?vue&type=script&lang=js&"
export * from "./seaCustomerConfig.vue?vue&type=script&lang=js&"
import style0 from "./seaCustomerConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports